export const SHOPIFY_OAUTH_STORAGE_KEY = "shopify-oauth";

export interface ShopifyOAuthStoredState {
  state: string;
  encryptedCreds: string;
  shop: string;
  locale?: string;
  createdAt: number;
}

const isShopifyOAuthStoredState = (value: unknown): value is ShopifyOAuthStoredState => {
  if (!value || typeof value !== "object") return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.state === "string" &&
    typeof v.encryptedCreds === "string" &&
    typeof v.shop === "string" &&
    typeof v.createdAt === "number" &&
    (v.locale === undefined || typeof v.locale === "string")
  );
};

const getStorage = (): Storage | undefined => {
  if (globalThis.window === undefined) return undefined;
  try {
    return globalThis.sessionStorage;
  } catch {
    return undefined;
  }
};

export const writeShopifyOAuthState = (value: Omit<ShopifyOAuthStoredState, "createdAt">) => {
  const storage = getStorage();
  if (!storage) return;
  const payload: ShopifyOAuthStoredState = { ...value, createdAt: Date.now() };
  storage.setItem(SHOPIFY_OAUTH_STORAGE_KEY, JSON.stringify(payload));
};

export const readShopifyOAuthState = (): ShopifyOAuthStoredState | undefined => {
  const storage = getStorage();
  if (!storage) return undefined;
  const raw = storage.getItem(SHOPIFY_OAUTH_STORAGE_KEY);
  if (!raw) return undefined;
  try {
    const parsed = JSON.parse(raw) as unknown;
    return isShopifyOAuthStoredState(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};

export const clearShopifyOAuthState = () => {
  const storage = getStorage();
  if (!storage) return;
  storage.removeItem(SHOPIFY_OAUTH_STORAGE_KEY);
};
